import React from 'react';
import { ReactComponent as SuccessIcon } from 'images/new-icons/check-mark-blue.svg';

const Success = () => {
  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100%',
        width: '100%',
        gap: 24
      }}
    >
      <SuccessIcon />
      <div
        style={{
          fontSize: 24,
          fontWeight: 700,
          fontFamily: 'Graphik Bold',
          width: 220,
          textAlign: 'center',
        }}
      >
        Your request is under review.
      </div>
    </div>
  );
};

export default Success;
